/**
 * The compare-seed hand-off, in its own module so the senders do not drag the
 * whole Compare view into the eager bundle.
 *
 * Two places queue exhibits for Compare without being Compare: the command
 * palette ("compare with <sample>") and the Mailbox bulk bar. Both used to
 * import `queueCompareSeed` and `COMPARE_MAX` straight from `CompareView`,
 * which made a static edge into a 100 kB view that the reader may never open.
 * A three-line module breaks that edge and lets `CompareView` be lazy.
 */

/** How many exhibits the comparison register holds. */
export const COMPARE_MAX = 6;

/**
 * Raw sources queued for the next Compare mount, consumed once. Module-level
 * on purpose: the sender navigates away in the same tick, so there is no
 * component alive to hold the value.
 */
const pendingSeeds: string[] = [];

export function queueCompareSeed(source: string): void {
  pendingSeeds.push(source);
}

/** Drain the queue. Returns everything queued since the last call. */
export function takeCompareSeeds(): string[] {
  return pendingSeeds.splice(0, pendingSeeds.length);
}
